import { request, requestFd } from '@/common/request';
import { clientPrefix, getTokenParams } from '@/config/base';
import { setToken } from '@/utils/cookies';
import { UCenter } from '@/services/user/data';

const chainPrefix = '/backend/chain';
const userPrefix = '/backend/user';
const depPrefix = 'hospital';

/**
 * 获取机构信息
 * @param params
 * @returns
 */
export const getPageChain = (params: any) => {
  // @ts-ignore
  return request.post<any, any>(`${chainPrefix}/pageChain`, params, { isReturnAllData: true });
};

/**
 * 添加机构
 * @param params
 * @returns
 */
export const chainSave = (params: any) => {
  // @ts-ignore
  return request.post<any, any>(`${chainPrefix}/save`, params, { isReturnAllData: true });
};

export const chainEdit = (params: any) => {
  // @ts-ignore
  return request.post<any, any>(`${chainPrefix}/edit`, params, { isReturnAllData: true });
};

/**
 *  设置机构状态
 * @param params
 * @returns
 */
export const setChainStatus = (params: any) => {
  // @ts-ignore
  return request.post<any, any>(`${chainPrefix}/setChainStatus`, params, { isReturnAllData: true });
};

/**
 * 删除机构
 * @param params
 * @returns
 */
export const chainDelete = (id: any) => {
  // @ts-ignore
  return request.post<any, any>(`${chainPrefix}/delete/${id}`);
};

export const chainDetail = (id: any) => {
  // @ts-ignore
  return request.post<any, any>(`${chainPrefix}/detail/${id}`);
};

/**
 * 获取机构信息
 * @param params
 * @returns
 */
export const getPageUserInfo = (params: any) => {
  return request.post<any, any>(`${clientPrefix}/user/pageUserInfo`, params, {
    // @ts-ignore
    isReturnAllData: true,
  });
};

export const userSave = (params: any) => {
  return request.post<any, any>(`${clientPrefix}/user/save`, params);
};

export const userEdit = (params: any) => {
  return request.post<any, any>(`${clientPrefix}/user/edit`, params);
};

export const userDetail = (id: any) => {
  return request.post<any, any>(`${clientPrefix}/user/detail/${id}`);
};

export const setUserStatus = (params: any) => {
  // @ts-ignore
  return request.post<any, any>(`${clientPrefix}/user/setUserStatus`, params);
};
export const userDelete = (id: any) => {
  return request.post<any, any>(`${clientPrefix}/user/delete/${id}`);
};

/**
 *获取科室列表
 * @param id
 * @returns
 */
export const listDepartment = (id: any) => {
  return request.post<any, any>(`${clientPrefix}/chain/listDepartment`, { chainId: id });
};

/**
 * 用户重置密码
 * @param id
 * @returns
 */
export const userResetPassword = (params: any) => {
  return request.post<any, any>('/uaa/user/resetPassword', params);
};

/**
 * 创建部门
 * @param params
 * @returns
 */
export const addDepartment = (params: any) => {
  // @ts-ignore
  return request.post<any, any>(`${depPrefix}/department/`, params, { isReturnAllData: true });
};

/**
 * 修改部门
 * @param params
 * @returns
 */
export const putDepartment = (params: any, id: any) => {
  // @ts-ignore
  return request.put<any, any>(`${depPrefix}/department/${id}`, params);
};

/**
 * 根据编号查询部门详情
 * @param params
 * @returns
 */
export const getDepartment = (id: any) => {
  // @ts-ignore
  return request.get<any, any>(`${depPrefix}/department/${id}`);
};
/**
 * 删除部门
 * @param params
 * @returns
 */
export const deleteDepartment = (id: any) => {
  // @ts-ignore
  return request.delete<any, any>(`${depPrefix}/department/${id}`);
};
/**
 * 查询部门树
 * @param params
 * @returns
 */
export const getDepartmentTree = () => {
  // @ts-ignore
  return request.get<any, any>(`${depPrefix}/department/tree`, { isReturnAllData: true });
};
/**
 * 启用部门
 * @param params
 * @returns
 */
export const putEnabled = (id: any) => {
  // @ts-ignore
  return request.put<any, any>(`${depPrefix}/department/status/enabled/${id}`);
};

/**
 * 停用部门
 * @param params
 * @returns
 */
export const putDisabled = (id: any) => {
  // @ts-ignore
  return request.put<any, any>(`${depPrefix}/department/status/disabled/${id}`);
};

// 获取医院列表（用于下拉选择）
export const getHospitalOptions = (params?: any) => {
  return request.post<any, any>(`${depPrefix}hospital/page`, { pageNo: 1, pageSize: 9999, ...params }, {
    // @ts-ignore
    isReturnAllData: true,
  });
};

/**
 * 科室管理相关接口
 */
// 分页查询科室列表
export const getPageDepartment = (params: any) => {
  // @ts-ignore
  return request.post<any, any>(`${depPrefix}clinic-department/page`, params, { isReturnAllData: true });
};

// 分页查询医生列表
export const getDoctorPage = (params: any) => {
  return request.post<any, any>(`${depPrefix}doctor/page`, params, {
    // @ts-ignore
    isReturnAllData: true,
  });
};

export default {};
